module.exports = __webpack_public_path__ + "static/media/smskod.794440b9.svg";